import React from "react";
import moment from "moment";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

const ClientPackagesList = ({ packages, onEdit }) => {
  if (!packages || packages.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        padding: "8px 16px",
        maxWidth: "260px",
      }}
    >
      {packages.map((pkg) => (
        <div
          key={pkg.id}
          onClick={() => onEdit(pkg)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "8px",
            padding: "6px 10px",
            borderRadius: "8px",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          <div style={{ overflow: "hidden" }}>
            <div
              style={{
                fontSize: "12px",
                fontWeight: 600,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {pkg.package_name}
            </div>
            <div style={{ fontSize: "10px", color: "#8a8a8a" }}>
              Od {moment(pkg.start_date).format("DD.MM.YYYY")}
            </div>
          </div>
          <EditRoundedIcon style={{ fontSize: "16px", color: "#2196F3", flexShrink: 0 }} />
        </div>
      ))}
    </div>
  );
};

export default ClientPackagesList;
